export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"name":"description","content":"Digital solutions for travel and transport companies: booking systems, real-time monitoring, automation, and back-office optimization."},{"hid":"image","name":"image","content":"/images/centourio_share.webp"},{"property":"og:title","content":"centour.io — Your Backend for Frontline Travel"},{"property":"og:description","content":"Digital solutions for travel and transport companies: booking systems, real-time monitoring, automation, and back-office optimization."},{"property":"og:image","content":"/images/centourio_share.webp"},{"name":"twitter:title","content":"centour.io — Your Backend for Frontline Travel"},{"name":"twitter:description","content":"Digital solutions for travel and transport companies: booking systems, real-time monitoring, automation, and back-office optimization."},{"name":"twitter:image","content":"/images/centourio_share.webp"},{"name":"twitter:card","content":"summary_large_image"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"}],"style":[],"script":[],"noscript":[],"title":"centour.io — Your Backend for Frontline Travel","viewport":"width=device-width, initial-scale=1, maximum-scale=5","htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false